import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

import { Effect, Actions } from '@ngrx/effects';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { NeoFrameService } from '../../../neo-frame/neo-frame.service';

import * as RouterActions from '../actions/router';
import { WindowRef } from '../../services/window-ref';
import * as AppStateActions from '../actions/app-state';
import { openNEOInNewTab } from '../reducers';
import * as selectors from '../reducers';

@Injectable()
export class RouterEffects {
	@Effect({ dispatch: false })
	navigate$ = this.actions$.ofType(RouterActions.GO)
		.map((action: RouterActions.Go) => action.payload)
		.do(({ path, query: queryParams, extras}) => this.router.navigate(path, { queryParams, ...extras }));

	@Effect({ dispatch: false })
	navigateBack$ = this.actions$.ofType(RouterActions.BACK)
		.do(() => this.location.back());

	@Effect({ dispatch: false })
	navigateForward$ = this.actions$.ofType(RouterActions.FORWARD)
		.do(() => this.location.forward());

	@Effect({ dispatch: false })
	onRouterNavigation$ = this.actions$.ofType('ROUTER_NAVIGATION')
		.do(routerNavigation => {
			this.window.nativeWindow['_mfq'].push([
				'newPageView',
				routerNavigation['payload'] && routerNavigation['payload']['routerState'] && routerNavigation['payload']['routerState'].url || '/',
			]);
		});

	@Effect({ dispatch: false })
	openNEO$ = this.actions$.ofType(RouterActions.OPEN_NEO)
		.switchMap(() => this.store.select(openNEOInNewTab))
		.do(settingEnabled => {
			if (settingEnabled) {
				this.neoFrameService.openInNewWindow();
			} else {
				this.store.dispatch(new RouterActions.Go({path: ['/neo']}));
			}
		});

	@Effect()
	openNeoFrame$ = this.actions$.ofType('ROUTER_NAVIGATION')
		.map(routerNavigation => routerNavigation['payload']['routerState'].url || '/')
		.filter(url => url === '/neo')
		.switchMap(() => Observable.of(new AppStateActions.OpenNeoFrame()));

	@Effect()
	closeNeo$ = this.actions$.ofType('ROUTER_NAVIGATION')
		.map(routerNavigation => routerNavigation['payload']['routerState'].url || '/')
		.filter(url => url !== '/neo')
		.switchMap(() => Observable.of(new AppStateActions.CloseNeoFrame()));

	@Effect()
	openArgus$ = this.actions$.ofType('ROUTER_NAVIGATION')
		.map(routerNavigation => routerNavigation['payload']['routerState'].url || '/')
		.filter(url => url === '/argus')
		.switchMap(() => Observable.of(new AppStateActions.OpenARGUSFrame()));

	@Effect()
	closeArgus$ = this.actions$.ofType('ROUTER_NAVIGATION')
		.map(routerNavigation => routerNavigation['payload']['routerState'].url || '/')
		.filter(url => url !== '/argus')
		.switchMap(() => Observable.of(new AppStateActions.CloseARGUSFrame()));

	constructor(
		private actions$: Actions,
		private router: Router,
		private location: Location,
		private window: WindowRef,
		private store: Store<selectors.State>,
		private neoFrameService: NeoFrameService
	) {}
}



// WEBPACK FOOTER //
// ./src/app/shared/state-management/effects/router.ts